export default "__VITE_ASSET__ValmzsV2__"